class ProductTabs extends HTMLElement {
    constructor() {
        super();

        this.tabs = this.querySelectorAll('.tab');
        this.contents = this.querySelectorAll('.content');
        console.log('click');
        this.tabs.forEach( (el, i) => {
            el.addEventListener('click', this.toggleTab.bind(this, el, i));
        })
    }

    toggleTab(el, index) {
        console.log(el);
        this.unActive(this.tabs);
        this.unActive(this.contents);
        el.classList.add('active');
        if(this.contents[index]) this.contents[index].classList.add('active');
    }

    unActive(array) {
        array.forEach( el => {
            el.classList.remove('active');
        })
    }
}

customElements.define('product-tabs', ProductTabs)